<div class="modal-body p-3 pb-5">
  <div class="headers">
    @if (deviceParams) {
      <h2>
        {{ 'GLOBAL.LAST_UPDATE'| translate: { time: (deviceParams.lastUpdate
        ? (deviceParams.lastUpdate | fromUTCToLocale | date: 'medium':timezone:lang)
        : '') } }}
      </h2>
    }
    <div class="table-action-box">
      <button
        class="button-primary"
        (click)="getParams()"
        [disabled]="isLoading || isSavingParams"
        >
        <i class="fa fa-sync-alt"></i>
        {{ 'GLOBAL.UPDATE' | translate }}
      </button>
      <button
        class="button-primary"
        (click)="downloadParams()"
        [disabled]="isLoading || isSavingParams || !dataSource.items"
        >
        <i class="fa fa-download"></i>
        {{ 'GLOBAL.EXPORT' | translate }}
      </button>
      @if (canEdit()) {
        <button
          class="button-primary"
          (click)="saveParams()"
          [disabled]="isLoading || isSavingParams || !dataSource.items"
          >
          <i class="fa fa-save"></i>
          {{ 'GLOBAL.SAVE' | translate }}
        </button>
      }
    </div>
  </div>

  <div class="table-container">
    <app-datatable
      [dataSource]="dataSource"
      [columns]="columns"
    ></app-datatable>
  </div>
</div>

<ng-template #valueTpl let-row="row">
  <input
    type="number"
    [readonly]="!canEdit()"
    class="custom-input"
    [(ngModel)]="row.value"
    [disabled]="isSavingParams"
    />
</ng-template>

